const html = window.html;
const Backbone = window.Backbone;

const FormatItemView = Backbone.View.extend({
    template: _.template(`
        <button class="BrowseFormats-link js-format" role="tab" aria-selected="false">
            <span></span>
        </button>`),

    events: {
        click: 'onClick',
    },

    initialize() {
        this.listenTo(this.model, 'change', this.render);

        this.setElement(this.template());
        this.$label = this.$('span');

        this.render();
    },

    onClick() {
        this.model.trigger('format:select', this.model);
    },

    render() {
        let model = this.model.toJSON();
        this.$label.text(model.label);

        this.$el.attr('id', `format-${model.mediaType}-tab`);
        this.$el.attr('aria-controls', `format-${model.mediaType}-panel`);

        // Some of the CSS transition styling depends on adding and removing the 'is-active' class so we are
        // incrementally updating the element instead of wiping out the display and re-rendering on update
        if (model.selected) {
            this.$el.addClass('is-active');
            this.$el.attr('aria-selected', 'true');
        } else {
            this.$el.removeClass('is-active');
            this.$el.attr('aria-selected', 'false');
        }
    },
});

const FormatNavigationView = Backbone.View.extend({
    template: `<div class="BrowseFormats" role="tablist" aria-label="${html(
        'advancedSearch.formatLabel'
    )}"></div>`,

    initialize() {
        this.listenTo(this.collection, 'sync', () => {
            this.setup();
        });
    },

    setup() {
        let $template = $(this.template);

        let activeFormats = this.collection.activeFormats();

        _(activeFormats).each((formatItem) => {
            $template.append(new FormatItemView({ model: formatItem }).el);
        });

        this.$el.empty().append($template);
    },
});

export default FormatNavigationView;
